import { forwardRef, type Ref, type SVGProps } from "react";
const IconLocationOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 4a8 8 0 0 1 8 8c0 5-4.92 11.6-8 15.07C12.92 23.6 8 17 8 12a8 8 0 0 1 8-8m0-2A10 10 0 0 0 6 12c0 8 10 18 10 18s10-10 10-18A10 10 0 0 0 16 2" /><path fill="currentColor" d="M16 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4" /></svg>;
const ForwardRef = forwardRef(IconLocationOutlineSVG);
ForwardRef.displayName = "IconLocationOutline";
export { ForwardRef as IconLocationOutline };